// Make announcement bar sticky alongside the header
(function() {
  function stickyAnnouncementBar() {
    const announcementBar = document.querySelector('.announcement-bar');
    const headerSection = document.querySelector('header-section');
    
    if (!announcementBar || !headerSection) return;

    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'position:sticky;top:0;z-index:1001;';
    
    announcementBar.parentNode.insertBefore(wrapper, announcementBar);
    wrapper.appendChild(announcementBar);
    wrapper.appendChild(headerSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stickyAnnouncementBar);
  } else {
    stickyAnnouncementBar();
  }
})();
